import { Icon as ReactIcon } from "@iconify/react/dist/iconify.js";
import { Box, IconButton, Tooltip, Typography, useTheme } from "@mui/material";
import { toPng } from "html-to-image";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { FiX } from "react-icons/fi";

const ImageUpload = ({ Icon, label, placeholder, onChange, disabled = false, preview, deletePreview = () => {}, accept, maxImageHeight = 380, maxImageWidth = 380 }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const ref = useRef(null);
  const previewRef = useRef(null);
  const filename = "image";
  const download = (ref, filename) => {
    if (ref.current) {
      toPng(ref.current)
        .then((dataUrl) => {
          const link = document.createElement("a");
          link.href = dataUrl;
          link.download = filename;
          link.click();
        })
        .catch((error) => {
          console.error("Error generating image:", error);
        });
    }
  };
  const clear = () => {
    if (ref.current) {
      ref.current.value = "";
      ref.current.type = "text";
      ref.current.type = "file";
    }
    deletePreview();
  };
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5, flex: 1 }}>
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Box sx={{ display: "flex", gap: 0.75 }}>
          {Icon && <Icon size={16} style={{ color: theme.palette.text.navigation, marginTop: "auto", marginBottom: "auto" }} />}
          {label && <Typography variant="Textbox Label">{t(label)}</Typography>}
        </Box>
        <Box sx={{ display: "flex", gap: 0.75 }}>
          {preview && (
            <Tooltip title={"Download"}>
              <IconButton
                onClick={() => {
                  download(previewRef, filename);
                }}
                sx={{
                  padding: 0,
                  color: isDark ? "#94a3b8" : "#999999",
                  "&:hover": { color: isDark ? "#f1f5f9" : "black", backgroundColor: "transparent" },
                }}>
                <ReactIcon icon="fe:download" style={{ color: "inherit", height: "15px" }} />
              </IconButton>
            </Tooltip>
          )}
          {preview && (
            <Tooltip title={"Delete"}>
              <IconButton
                onClick={() => {
                  clear();
                }}
                sx={{ padding: 0, color: isDark ? "#94a3b8" : "#999999", "&:hover": { color: isDark ? "#f1f5f9" : "black", backgroundColor: "transparent" } }}>
                <FiX size={16} />
              </IconButton>
            </Tooltip>
          )}
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          backgroundColor: isDark ? "#27272a" : "#f9fafb",
          flexGrow: 1,
          flexDirection: "column",
          borderWidth: 2,
          borderRadius: 1,
          borderStyle: "dashed",
          borderColor: isDark ? "#3f3f46" : "#d1d5db",
          "&:hover": { borderColor: isDark ? "#4ade80" : "#10b981" },
        }}
        style={{ flex: 1 }}
        onClick={disabled ? undefined : () => ref.current.click()}>
        <input type="file" accept={accept} ref={ref} onChange={onChange} disabled={disabled} style={{ display: "none" }} />
        {!preview ? (
          <Box sx={{ marginY: "auto" }}>
            <Typography sx={{ color: isDark ? "#94a3b8" : "#6b7280", fontSize: 14, fontFamily: "Poppins", textAlign: "center" }}>{t(placeholder)}</Typography>
          </Box>
        ) : (
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <img src={preview} ref={previewRef} style={{ height: "auto", maxWidth: maxImageWidth, maxHeight: maxImageHeight }} alt="Image not available" />
          </Box>
        )}
      </Box>
    </Box>
  );
};
export default ImageUpload;
